import { Typography, Avatar, Button } from "@mui/material";
import slackImage from "@/images/slack.webp";

const SlackButton = ({
  shareLink,
  rawText,
  title,
  insightSummary,
  organizationName,
}: {
  shareLink: string;
  rawText: string;
  title: string;
  insightSummary?: string;
  organizationName: string;
}) => {
  const openSlack = () => {
    const text = [
      insightSummary || "<<Your Text Here>>",
      "Add some context on this clip for your recipient.",
      `Check out this Cloverleaf AI clip. ${shareLink}`,
      `Government Agency: ${organizationName}`,
      `Meeting Name: ${title}`,
      `Clip Text: "${rawText}"`,
    ].join("\n\n");

    // Copy text to clipboard
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // Open Slack
        window.open("slack://open");
      })
      .catch((err) => {
        console.error("Failed to copy text to clipboard:", err);
        // Fallback: open Slack anyway
        window.open("slack://open");
      });
  };

  return (
    <Button
      className="flex flex-col items-center rounded-xl"
      onClick={openSlack}
    >
      <Avatar
        aria-label="slack"
        variant="square"
        src={slackImage.src}
        sx={{
          height: "60px",
          width: "60px",
        }}
      />
      <Typography variant="h6">Slack</Typography>
    </Button>
  );
};

export default SlackButton;
